import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { SharedModule } from '@primeng/api';
import { Table } from '@primeng/table';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ModalService } from '@shared/services/modal/modal.service';
import {
  AddPersonComponent
} from '@modules/universal-billing/properties/property-profile/tabs/object-resposible/add-person/add-person.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Resources} from '@app/resources';
import {ContractsService} from '@modules/universal-billing/property-management/contracts/contracts.service';
import {BasicTableComponent} from '@common/references/basic-table.component';
import {PTableCellValueComponent} from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import {TooltipModule} from '@primeng/tooltip';
import {ReferenceField} from '@common/references/reference-field';
import {RouterLink} from '@angular/router';
import {ResourceByIdPipe} from '@shared/pipes/resource-by-id.pipe';
import { ContractComponent } from '@modules/universal-billing/contract/contract.component';
import { ModalClose } from '@shared/services/modal/modal.enum';
import urlJoin from 'url-join';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {PageResult} from '@shared/components/classes/page-result';
import {Apartment} from '@modules/universal-billing/apartments/apartments.interface';
import { Property } from '@modules/universal-billing/properties/properties.interface';
import { StoreBackRouteDirective } from '@common/directive/store-back-route.directive';
import { RentType } from '@modules/universal-billing/residents/resident.enum';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'contracts',
  standalone: true,
  imports: [
    SharedModule,
    Table,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    PTableCellValueComponent,
    TooltipModule,
    RouterLink,
    ResourceByIdPipe,
    StoreBackRouteDirective,
    NgbTooltip,
    LocalizedDatePipe,
    DatePipe
  ],
  templateUrl: './contracts.component.html',
  styleUrl: './contracts.component.scss'
})
export class ContractsComponent extends BasicTableComponent<any> implements OnInit {
  @Input() apartment: Apartment;
  @Input() property: Property;
  @Output() successEvent = new EventEmitter();

  modalService = inject(ModalService);
  translate = inject(TranslateService);
  service = inject(ContractsService);
  _http = inject(HttpClient);

  fields: ReferenceField[] = [
    {fieldName: 'fullName', label: 'APARTMENT.FULLNAME', iconClass: 'ri-file-edit-line'},
    {fieldName: 'contractNumber', label: 'CONTRACT.NUMBER', iconClass: 'ri-list-ordered'},
    {fieldName: 'rentType', label: 'APARTMENT.TYPE', iconClass: 'ri-exchange-funds-line'},
    {fieldName: 'status', label: 'CITY.STATUS', viewType: 'status', iconClass: 'las la-toggle-on'},
    {fieldName: 'startDate', label: 'PROPERTY.BEGIN', viewType: 'date', iconClass: 'ri-time-line'},
    {fieldName: 'endDate', label: 'PROPERTY.END', viewType: 'date', iconClass: 'ri-time-line'},
    {fieldName: 'totalRent', label: 'CONTRACTS.AMOUNT_MONTHLY', viewType:"money", iconClass: 'ri-money-euro-circle-line'},
    {fieldName: 'actions', label: 'READINGS.ACTIONS', iconClass: 'ri-grid-fill'}
  ];

  addContract() {
      this.modalService.open({
        title: '',
        component: ContractComponent,
        modalOptions: {
          size: 'xl',
          withoutBody: true
        },
        componentOptions: {
          apartment: this.apartment,
          property: this.property,
        },
      }).then(value => {
        if (value == ModalClose.SUCCESS) {
          this.successEvent.emit();
        }
      })
    }

  getAll(params: any): Observable<PageResult<Apartment>> {
    params.buildingId = this.property?.id;
    params.apartmentId = this.apartment?.id;
    return super.getAll(params);
  }
  inProcess() {
    this.modalService.open({
      component: AddPersonComponent,
      title: '',
      componentOptions: {},
      modalOptions: {
        size: 'sm',
      }
    })
  }

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'rental-contracts');
  }

  delete(id) {
    this.confirmModalService.open().then((res) => {
      if (res) {
        this._http.delete(urlJoin(this.getUrl(), String(id))).subscribe(
          () => {
            this.sweetAlertService.success('', 'TOAST.TOAST_DELETE').then(r => {
              this.successEvent.emit();
            });
          },
          (error) => this.alertErrorMessage(error?.error?.message)
          )
      }
    })
  }

  protected readonly Resources = Resources;
  protected readonly RentType = RentType;
}
